// @flow
import * as React from 'react';
import { getUserName, useDebouncedMemo } from '@coverright/utils';
import { TextInput } from '@coverright/ui/inputs';
import { Autocomplete, SxProps } from '@mui/material';
import { useState } from 'react';
import { SearchForClientGroupQuery, useSearchForClientGroupQuery } from '../shared';

type Client = SearchForClientGroupQuery['clientViews']['data'][0];

type Props = {
  value?: Client;
  onChange: (value: Client | null) => void;
  sx?: SxProps;
  label?: string;
  disabled?: boolean;
  error?: string;
};
export const ClientSelector = (props: Props) => {
  const [searchTerm, setSearchTerm] = useState(props.value ? getUserName(props.value) : '');
  const debouncedSearchTerm = useDebouncedMemo(searchTerm, 400)
  const [value, setValue] = useState(props.value || null);

  const {data, loading, previousData} = useSearchForClientGroupQuery({
    variables: {
      pageInput: {page: 0, size: 100},
      filterInput: {searchTerm: debouncedSearchTerm},
    },
    notifyOnNetworkStatusChange: true,
    skip: !debouncedSearchTerm || debouncedSearchTerm.length < 2,
  })

  let options = (data || previousData)?.clientViews.data ||  [];

  if (!options.length && props.value) {
    options = [props.value as any]
  }

  return (
    <Autocomplete fullWidth
                  sx={props.sx}
                  disabled={props.disabled}
                  loading={loading}
                  options={options}
                  value={value}
                  filterOptions={o => o}
                  onInputChange={(event, newInputValue) => {
                    setSearchTerm(newInputValue);
                  }}
                  getOptionKey={v => v.clientId}
                  getOptionLabel={getUserName}
                  onChange={(event, v) => {
                    props.onChange(v as any);
                    setValue(v as any)
                    setSearchTerm('')
                  }}
                  clearOnBlur
                  renderInput={(params) => <TextInput
                    hideTick
                    label={props.label || 'Search client'}
                    value={searchTerm}
                    error={!!props.error}
                    helperText={props.error}
                    {...params}
                  />} />
  );
};
